import type {
  SnackBarConfig,
} from '@shared/components/Snackbar';
import { useContext, useState } from 'react';
import { Container } from '@shared/components/Container';
import { LoadingSpinner } from '@shared/components/LoadingSpinner';
import CustomSnackbar from '@shared/components/Snackbar';
import StaticTextCard from '@shared/components/StaticTextCard';
import { UserContext } from '@/shared/contexts/UserContext';
import AdminTabs from './components/AdminTabs';

function AdminPage() {
  const [snackbarConfig, setSnackbarConfig] = useState<SnackBarConfig>();

  const { user } = useContext(UserContext);

  const handleSnackBarClose = () => {
    setSnackbarConfig({ ...snackbarConfig, open: false });
  };

  if (!user) {
    return <LoadingSpinner variant="linear" size="medium" />;
  }

  if (!user.isAdmin) {
    return (
      <StaticTextCard
        header="Unauthorized"
        text="You are not authorized to view this page."
        link={false}
      />
    );
  }

  return (
    <Container isWhite sx={{ p: 0 }}>
      <AdminTabs />
      <CustomSnackbar config={snackbarConfig} setOpen={handleSnackBarClose} />
    </Container>
  );
}

export default AdminPage;
